

import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_180_0_FieldSet";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_180_0_FieldSet__root","children":"wds_1_180_0_FieldSet__children","labelIndicators":"wds_1_180_0_FieldSet__labelIndicators","labelRow":"wds_1_180_0_FieldSet__labelRow","labelRowMain":"wds_1_180_0_FieldSet__labelRowMain","suffixRow":"wds_1_180_0_FieldSet__suffixRow","visuallyHidden":"wds_1_180_0_FieldSet__visuallyHidden"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"labelChildrenSpacingMap":{"tiny":"var(--wds-field-set-label-gap-tiny, 9px)","small":"var(--wds-field-set-label-gap-small, 9px)"},"labelGap":"6px"}; 
export var vars = {"wds-field-set-gap-small":"--wds-field-set-gap-small","wds-field-set-gap-medium":"--wds-field-set-gap-medium","wds-field-set-gap-large":"--wds-field-set-gap-large","wds-field-set-label-gap-small":"--wds-field-set-label-gap-small","wds-field-set-label-gap-tiny":"--wds-field-set-label-gap-tiny"}; 




